@if (hasAnyPermission) {
  <button
    [matMenuTriggerFor]="productActionsMenu"
    mat-icon-button
    matTooltip="Product actions"
    color="primary"
    matTooltipPosition="right"
    class="mat-elevation-z0"
    >
    <mat-icon>inventory_2</mat-icon>
  </button>
}
<mat-menu #productActionsMenu="matMenu">
  @if (sectionVisible['PREP']) {
    <div mat-subheader>PREP</div>
  }
  <app-group-ingest-action
    [selectedProducts]="selectedProducts"
    (actionComplete)="actionComplete.emit()"
    (visibilityDeclared)="onChildVisibility('PREP', $event)"
  ></app-group-ingest-action>
  <app-mastersuite-apply-menu-item
    [selectedProducts]="selectedProducts"
    [masterSuites]="masterSuites"
    (actionComplete)="actionComplete.emit()"
    (visibilityDeclared)="onChildVisibility('PREP', $event)"
  ></app-mastersuite-apply-menu-item>

  @if (sectionVisible['ENHANCEMENT']) {
    <div mat-subheader>ENHANCEMENT</div>
  }
  <app-export-shoot-assets-action
    [selectedProducts]="selectedProducts"
    [organizationId]="organizationId"
    [batchId]="batchId"
    (visibilityDeclared)="onChildVisibility('ENHANCEMENT', $event)"
  ></app-export-shoot-assets-action>

  @if (sectionVisible['DELIVERY']) {
    <div mat-subheader>DELIVERY</div>
  }
  <app-create-collection-wizard-action
    [selectedProducts]="selectedProducts"
    [organizationId]="organizationId"
    [batchId]="batchId"
    (visibilityDeclared)="onChildVisibility('DELIVERY', $event)"
  ></app-create-collection-wizard-action>
</mat-menu>
